import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  mutation CreateSubscriptionV2ByToken($payload: AutoFilledCreateSubscriptionPayload!, $token: String!) {
    createSubscriptionV2ByToken(payload: $payload, token: $token) {
      nextAction
      subscription {
        startDate
        endDate
        cancelDate
        frequency
        status
        amountDue
        lastPaymentDate
        _id
        updatedAt
        createdAt
        nextBillingDate
        product {
          name
        }
        pricing {
          name
        }
      }
    }
  }
`;
